export interface AppColors {
  primary: string;
  danger: string;
  warning:string;
  success:string;
  teal:string;
  fuchsia:string;
  dark:string;
  info:string;
  mute:string;
  white:string;
  black:string;
  default:string;
  [key: string]: string;
}

export interface AppConfig {
  readonly version: string;
  readonly AVATAR_256: string;
  readonly AVATAR_64: string;
  readonly AVATAR_URL: string;
  readonly APP_URL: string;
  readonly timelineColors: AppColors;
  readonly colors: AppColors;
  readonly colorNames: Record<string, string>;
  readonly viewerErrors: string[];
}

export const Config: AppConfig = {
  version: "1.18.12",
  AVATAR_256: '/avatars/256/avatar_256_',
  AVATAR_64: '/avatars/64/avatar_64_',
  AVATAR_URL: '/avatars/',
  APP_URL: 'https://api.cad42.com',

  timelineColors: {
    warning: "#FF6600",
    danger: "#dd4b39",
    primary: "#00a65a",
    success: "#3c8dbc",
    teal: "#39CCCC",
    fuchsia: "#F012BE",
    dark: "#010101",
    info: "#666666",
    mute: "#808080",
    muted: "#808081",
    white: "#FFFFFF",
    black: "#000000",
    default: "#99BBAA"
  },

  colors: {
    worker: "#0066ff",
    crane: "#ffa500",
    equipment: "#ff3300",
    event: "#eebb39",
    warning: "#FF6600",
    danger: "#dd4b39",
    success: "#00a65a",
    primary: "#3c8dbc",
    lemon: "#f3e612",
    teal: "#39CCCC",
    fuchsia: "#F012BE",
    dark: "#010101",
    info: "#666666",
    mute: "#808080",
    muted: "#808081",
    white: "#FFFFFF",
    black: "#000000",
    default: "#99BBAA"
  },

  colorNames: {
    "#0066ff": "worker",
    "#ffa500": "crane",
    "#ff3300": "equipment",
    "#eebb39": "event",
    "#FF6600": "warning",
    "#dd4b39": "danger",
    "#00a65a": "success",
    "#3c8dbc": "primary",
    "#f3e612": "lemon",
    "#39CCCC": "teal",
    "#F012BE": "fuchsia",
    "#010101": "dark",
    "#666666": "info",
    "#808080": "mute",
    "#808081": "muted",
    "#FFFFFF": "white",
    "#000000": "black",
    "#99BBAA": "default"
  },

  viewerErrors: [
    "UNKNOWN_FAILURE: An unknown failure has occurred.",
    "BAD_DATA: Bad data (corrupted or malformed) was encountered.",
    "NETWORK_FAILURE: A network failure was encountered.",
    "NETWORK_ACCESS_DENIED: Access was denied to a network resource (HTTP 403)",
    "NETWORK_FILE_NOT_FOUND: A network resource could not be found (HTTP 404)",
    "NETWORK_SERVER_ERROR: A server error was returned when accessing a network resource (HTTP 5xx)",
    "NETWORK_UNHANDLED_RESPONSE_CODE: An unhandled response code was returned when accessing a network resource (HTTP 'everything else')",
    "BROWSER_WEBGL_NOT_SUPPORTED: Browser error: webGL is not supported by the current browser",
    "BAD_DATA_NO_VIEWABLE_CONTENT: There is nothing viewable in the fetched document",
    "BROWSER_WEBGL_DISABLED: Browser error: webGL is supported, but not enabled",
    "BAD_DATA_MODEL_IS_EMPTY: There is no geometry in loaded model",
    "RTC_ERROR: Collaboration server error",
    "UNSUPPORTED_FILE_EXTENSION: The extension of the loaded file is not supported",
    "VIEWER_INTERNAL_ERROR: Viewer error: wrong or forbidden usage of the viewer"
  ]
};
